export default __webpack_public_path__ + "static/media/logo-sicurieprotetti.044fc9f8.png";